import { useState, useEffect } from 'react';
import { SnowEffect } from './components/SnowEffect';
import { HeroSection } from './components/HeroSection';
import { CertificateCard } from './components/CertificateCard';
import { getRecipient, getRecipientName, getCompanionName } from './utils/routing';
import './index.css';

export function App() {
  const [isRevealed, setIsRevealed] = useState(false);
  const [recipient, setRecipient] = useState<'mama' | 'dasha'>('mama');
  
  useEffect(() => {
    setRecipient(getRecipient());
  }, []);
  
  const recipientName = getRecipientName(recipient);
  const companionName = getCompanionName(recipient);
  
  return (
    <div className="relative">
      <SnowEffect />
      
      {!isRevealed ? (
        <HeroSection
          recipientName={recipientName}
          onReveal={() => setIsRevealed(true)}
          isRevealed={isRevealed}
        />
      ) : (
        <CertificateCard
          recipientName={recipientName}
          companionName={companionName}
        />
      )}
    </div>
  );
}

export default App;
